export function _formatJsDate(date) {
  let options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  let dateFormatter = new Intl.DateTimeFormat(undefined, options);
  return dateFormatter.format(date);
};
